export enum RoomAction {
  Clone = 'clone',
  Create = 'create',
  Edit = 'edit',
}

export enum RoomSection {
  QA = 'qa',
}
